import { PageInterface } from "interfaces/page.interface";
import { TxInterface } from "interfaces/tx.interface";

export enum TxsActionTypes {
  FETCH_TXS_REQUEST = "FETCH_TXS_REQUEST",
  FETCH_TXS_SUCCESS = "FETCH_TXS_SUCCESS",
  FETCH_TXS_FAILURE = "FETCH_TXS_FAILURE",
}

// Action interfaces
export interface FetchTxsRequestAction {
  type: TxsActionTypes.FETCH_TXS_REQUEST;
  payload: {
    page: number;
    take: number;
  };
}

export interface FetchTxsSuccessAction {
  type: TxsActionTypes.FETCH_TXS_SUCCESS;
  payload: PageInterface<TxInterface>;
}

export interface FetchTxsFailureAction {
  type: TxsActionTypes.FETCH_TXS_FAILURE;
  payload: string;
}

// Action creators
export const fetchTxsRequest = (
  page: number,
  take: number
): FetchTxsRequestAction => ({
  type: TxsActionTypes.FETCH_TXS_REQUEST,
  payload: { page, take },
});

export const fetchTxsSuccess = (
  data: PageInterface<TxInterface>
): FetchTxsSuccessAction => ({
  type: TxsActionTypes.FETCH_TXS_SUCCESS,
  payload: data,
});

export const fetchTxsFailure = (error: string): FetchTxsFailureAction => ({
  type: TxsActionTypes.FETCH_TXS_FAILURE,
  payload: error,
});

export type TxsActions =
  | FetchTxsRequestAction
  | FetchTxsSuccessAction
  | FetchTxsFailureAction;
